import * as React from "react";

const intents = new Map<string, () => void>();

/** Page-local create handler for a fabConfig action that cannot be a plain URL. */
export function useFabIntent(id: string, handler: () => void): void {
  const ref = React.useRef(handler);
  ref.current = handler;
  React.useEffect(() => {
    const run = () => ref.current();
    intents.set(id, run);
    return () => {
      if (intents.get(id) === run) intents.delete(id);
    };
  }, [id]);
}

export function runFabIntent(id: string): boolean {
  const run = intents.get(id);
  if (!run) return false;
  run();
  return true;
}
